"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MapPin, Phone, Mail, Linkedin } from "lucide-react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm">
            Contact Us
          </Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function FooterInformation() {
  const regionalFocus = ["WA Government", "Energy & Resources", "Utilities & Infrastructure"];
  const contactDetails = [{
    icon: MapPin,
    text: "Western Australia, Australia"
  }, {
    icon: Phone,
    text: "0417 268 353"
  }, {
    icon: Mail,
    text: "robert@momentumconsultants.com.au"
  }];
  return <section id="footer-information" className="dark bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1619832/img/momentum-consultants-logo.png" alt="Momentum Logo" className="h-7 mb-6 object-contain" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-xs">
              A technology innovator operating for 28 years, since 1998. We deliver certainty in complex environments through high-value, end-to-end consulting.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold mb-6 tracking-tight">Quick Links</h3>
            <MenuProvider menu_id="47">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold mb-6 tracking-tight">Regional Focus</h3>
            <ul className="space-y-3">
              {regionalFocus.map((focus, i) => <li key={i} data-index={i} className="flex items-center gap-2 text-sm text-muted-foreground">
                  <div className="size-1.5 rounded-full bg-primary/50" />
                  {focus}
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-lg font-semibold mb-6 tracking-tight">Contact Us</h3>
            <ul className="space-y-4">
              {contactDetails.map((detail, i) => {
              const Icon = detail.icon;
              return <li key={i} data-index={i} className="flex items-start gap-3 text-sm text-muted-foreground">
                    <Icon className="size-5 shrink-0 text-primary" />
                    <span>{detail.text}</span>
                  </li>;
            })}
            </ul>
          </div>
        </div>

        <Separator className="bg-border mb-8" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>© 2026 Momentum Consultants. All rights reserved.</p>
          
          <div className="flex items-center gap-6">
            <Link to="#" className="hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-primary transition-colors" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}